import axios from 'axios';

import { URL_CONSTANTS } from '../../../../constants/urlConstants';
import {
  HdOverrideReasonType,
  LeadResponseValues,
  saveSystemLLrpConfigurationPayload,
} from '../interfaces/epa-lead.interface';
import apiService from '../../../../services/api.service';

export const getHomeDepotOverrideReasons = async () => {
  try {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/system/reason?reasonType=Override%20Reason&sourceSystemId=2`
    );
    const filteredData = response?.data?.filter(
      (item: HdOverrideReasonType) => item?.reason_type === 'Override Reason'
    );
    return filteredData;
  } catch (error) {
    console.error(error);
  }
};

export const getHdEpaDocs = async (projectId?: string | number) => {
  try {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/projects/${projectId}/hd-epa-docs`
    );
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const getProjectInstallers = async (projectId: string) => {
  try {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/projects/${projectId}/project-installer`
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getUserId = async (schedulerUserId: string) => {
  try {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/auth/user/manage/${schedulerUserId}`
    );
    return response?.data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const getLLrpData = async (projectId: string) => {
  try {
    const response = await apiService.get(
      `/system/lrrp-configuration/${projectId}`
    );
    return response;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const systemLLrpConfiguration = async (projectId: string) => {
  try {
    const response = await apiService.get(
      `/system/lrrp-configuration-trigger/${projectId}`
    );
    return response;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const saveSystemLLrpConfiguration = async (
  projectId: string,
  payload: saveSystemLLrpConfigurationPayload
) => {
  try {
    const response = await apiService.post(
      `/system/lrrp-configuration-trigger/${projectId}`,
      payload
    );
    return response;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const saveSystemLLrp = async (
  projectId: string,
  payload: LeadResponseValues
) => {
  try {
    const response = await apiService.post(
      `/system/lrrp-configuration/${projectId}`,
      payload
    );
    return response;
  } catch (error) {
    console.error(error);
    return {};
  }
};
